module.exports = __webpack_public_path__ + "static/media/port_charlotte_bottle.ea4fbe86.jpg";